module.exports = __webpack_public_path__ + "static/media/warnning-icon.a4ee54de.svg";